<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <Projects :product-id="packageId" />
    </div>
  </div>
</template>

<script>
import Projects from 'Components/ProductProjects/Projects.vue';

export default {
  components: {
    Projects,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
};
</script>
